export class InventoryLookupRequest {
  /** @type {string} */
  sku;

  /** @type {number} */
  quantity = 1;

  /** @type {string[]} */
  branchLocations = [];

  static forOne() {
    const instance = new InventoryLookupRequest();
    instance.quantity = 1;
    return instance;
  }

  get isValid() {
    /** @type {boolean[]}*/
    const tests = []
    tests.push(!!this.sku);
    tests.push(!isNaN(Number(this.quantity)));
    tests.push(Array.isArray(this.branchLocations) && this.branchLocations.length > 0);
    const maybe = tests.every(it => it);
    return maybe;
  }

  withSku(sku) {
    this.sku = sku;
    return this;
  }

  withQuantity(quantity) {
    this.quantity = quantity;
    return this;
  }

  withBranchLocations(branchLocations) {
    if (Array.isArray(branchLocations)) {
      this.branchLocations = branchLocations;
    }
    return this;
  }

  withBranchLocation(branchLocation) {
    this.branchLocations ??= [];
    this.branchLocations.length = 0;
    this.branchLocations.push(branchLocation);
    return this;
  }

  toString() {
    return JSON.stringify(this);
  }
}

export class InventoryLookupResponseBranchLocation {
  /** @type {string} */
  locationId;
  /** @type {string} */
  locationName;
  /** @type {number} */
  quantity;
  /** @type {number} */
  availableQuantity;
  /** @type {number} */
  inTransitQuantity;
  /** @type {number} */
  leadTimeDays;

  /**
   * @param json
   * @returns {InventoryLookupResponseBranchLocation}
   */
  fromJson(json) {
    this.locationId = json.locationId;
    this.locationName = json.locationName;
    this.quantity = json.quantity;
    this.availableQuantity = json.availableQuantity;
    this.inTransitQuantity = json.inTransitQuantity;
    this.leadTimeDays = json.leadTimeDays;
    return this;
  }
}

export class InventoryLookupResponse {
  /** @type {string} */
  sku;
  /** @type {string} */
  name;
  /** @type {string} */
  description;
  /** @type {string} */
  unitOfMeasure;
  /** @type {InventoryLookupResponseBranchLocation[]} */
  locations = [];
  /** @type {number} */
  totalAvailable = 0;
  /** @type {number} */
  totalInTransit = 0;
  /** @type {boolean} */
  isAvailable = false;

  /**
   * @param json
   * @returns {InventoryLookupResponse}
   */
  fromJson(json) {
    this.sku = json.sku;
    this.name = json.name;
    this.description = json.description;
    this.unitOfMeasure = json.unitOfMeasure;
    this.locations = json.locations.map(it => {
      const location = new InventoryLookupResponseBranchLocation()
        .fromJson(it);
      return location;
    });
    return this;
  }
}
